import {useSelector} from "react-redux";

import {Country} from "@pg-rp/common-types";
import {useMapRegionDistrictsAndSurroundings} from "@pg-rp/interactive-regions-map";
import {InteractiveRegionsMapContext} from "@pg-rp/interactive-regions-map/src/context/InteractiveRegionsMapContext";

import {IRPStore} from "../../../../app/rp_reducer";
import {ForYouBanner} from "../../../../for_you/components/ForYouBanner";
import {useLazyGetMapRegionsQuery} from "../../../map/api/get_map_region";
import {useLazyGetMapRegionDistrictsAndSurroundingsQuery} from "../../../map/api/get_map_region_districts_and_surroundings";
import {MidListingBannerBox} from "./MidListingBannerBox";

export function OfferListMidBanner() {
    const [getMainRegionLazy] = useLazyGetMapRegionsQuery();
    const getMainRegion = (parentId: number) => {
        return getMainRegionLazy({region: parentId}, true)
            .unwrap()
            .then((response) => {
                return response?.results?.[0] || null;
            });
    };

    const [getDistrictsAndSurroundingsLazy] = useLazyGetMapRegionDistrictsAndSurroundingsQuery();
    const getDistrictsAndSurroundings = (parentId: number) => {
        return getDistrictsAndSurroundingsLazy({parent: parentId}, true)
            .unwrap()
            .then((response) => {
                return response?.results || null;
            });
    };

    const selectedRegions = useSelector((state: IRPStore) => state.offerList.selectedRegions);

    return (
        <InteractiveRegionsMapContext.Provider
            value={{
                selectedRegions,
                getMainRegion,
                getDistrictsAndSurroundings,
                handleUpdateRegions: () => {
                    //This should not run, banner is not managing regions, just displaying data
                }
            }}
        >
            <MidBannerVariant />
        </InteractiveRegionsMapContext.Provider>
    );
}

function MidBannerVariant() {
    const {hasAnyDistrictsOrSurroundings} = useMapRegionDistrictsAndSurroundings();
    const offerList = useSelector((state: IRPStore) => state.offerList.list);
    const offerType = offerList.latestQuery.type ? parseInt(offerList.latestQuery.type) : undefined;
    const searchFormValues = useSelector((state: IRPStore) => state.search.formValues);
    const selectedRegions = useSelector((state: IRPStore) => state.offerList.selectedRegions);

    if (hasAnyDistrictsOrSurroundings && selectedRegions && !selectedRegions.find((region) => region.country === Country.SPAIN)) {
        return <ForYouBanner selectedRegion={selectedRegions} offerTypes={searchFormValues.type} />;
    }

    return <MidListingBannerBox offerType={offerType} selectedRegions={selectedRegions} offerCount={offerList.propertiesCount} className="listing-banner" />;
}
